import { IHomeAddress } from '~/components/HomeAddress/HomeAddress';
import { ILoanPurpose } from '~/components/LoanPurpose/LoanPurpose';
import { IErrorMessages } from '~/services/ErrorMessageService';
import { ICombinedTranslations } from '~/translations';
import { IPage, ISettings } from './SharedInterfaces';
import { ICardPurpose } from '~/components/CardPurpose/CardPurpose';

export interface IDocumentUploadState {
  objectURL: string;
  name: string;
  size: number;
}

export enum ESignupComponents {
  loanAmount = 'loanAmount',
  orgNumber = 'orgNumber',
  phoneNumber = 'phoneNumber',
  loanTerm = 'loanTerm',
  emailAddress = 'emailAddress',
  termsAgreement = 'termsAgreement',
  website = 'website',
  homeAddress = 'homeAddress',
  cardPurpose = 'cardPurpose',
  turnover = 'turnover',
}

export enum EOnboardingComponents {
  bankIntegration = 'bankIntegration',
  loanPurpose = 'loanPurpose',
  documentUpload = 'documentUpload',
  personalNumber = 'personalNumber',
  turnover = 'turnover',
}

export enum EPrefillableComponents {
  loanAmount = 'loanAmount',
  loanTerm = 'loanTerm',
  orgNumber = 'orgNumber',
  emailAddress = 'emailAddress',
  phoneNumber = 'phoneNumber',
  personalNumber = 'personalNumber',
  turnover = 'turnover',
  loanPurpose = 'loanPurpose',
  cardPurpose = 'cardPurpose',
  website = 'website',
}

export interface ISignupState {
  readonly loanAmount?: string;
  readonly orgNumber?: string;
  readonly phoneNumber?: string;
  readonly loanTerm?: number;
  readonly emailAddress?: string;
  readonly website?: string;
  readonly termsAgreement?: boolean;
  readonly homeAddress?: IHomeAddress;
  readonly cardPurpose?: ICardPurpose;
  readonly turnover?: string;
}

export interface IOnboardingState {
  readonly bankIntegration?: boolean;
  readonly loanPurpose?: ILoanPurpose;
  readonly documentUpload?: IDocumentUploadState[];
  readonly personalNumber?: string;
  readonly turnover?: string;
}

export interface IErrorState extends IErrorMessages {}

export interface IWidgetContext {
  pages: IPage[];
  currentPage: number;
  locale: keyof ICombinedTranslations;
  settings: ISettings;
  sessionId: string;
  isCompanyValid?: boolean;
  isAdditionalHouseNumberRequired?: boolean;
  signupCompleted: boolean;
  signupNewCustomer: boolean | null;
  cardApplicationId: string;
  widgetFinished: boolean;
  loading: boolean;
  isInitiated: boolean;
  accessToken: string;
  clientId: number;
}

export interface IState {
  signup: ISignupState;
  onboarding: IOnboardingState;
  error: IErrorState;
  widgetContext: IWidgetContext;
}
